import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import JoditEditor from "jodit-react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { FileUploader } from "react-drag-drop-files";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from '@mui/material/MenuItem';
import axios from "axios";

import {
  Alert,
  CircularProgress,
  FormControl,
  IconButton,
  Switch,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import ListTile from "./ListTile";
import { Close, CloseRounded } from "@mui/icons-material";
import { useForm, Controller } from "react-hook-form";
import { useEffect } from "react";
import { getError, getSuccessMessage } from "../store/helpers/common_functions";
import { successToast } from "./Notification";
import moment from "moment";
import QtMaterialButton from "../components/QtMaterialButton";
import { getDateList, monthList } from "./Common_functions";
import DatePicker from "react-multi-date-picker";
import { mapStateToProps } from "store/helpers/mapState";

const cheerio = require("cheerio");
const fileTypes = [
  "PDF",
  "JPG",
  "JPEG",
  "PNG",
  "GIF",
  "DOCX",
  "DOC",
  "XLSX",
  "XLS",
];


export function CheckBoxItem({ item }) {
  return (
    <div className={"flex flex-wrap"}>
      {item.values?.map((v) => (
        <div
          className={`w-full lg:w-${item.checkCol ?? 6}/12 xl:w-${item.checkCol ?? 6
            }/12 px-2`}
        >
          <ListTile
            selected={item.value?.filter((i) => i === v.value)?.length > 0}
            handleToggle={(it) => {
              if (item.setValue && typeof item.setValue === "function") {
                if (item.value?.filter((i) => i === v.value)?.length > 0) {
                  item.setValue(item.value.filter((i) => i !== v.value));
                } else if (item.value?.length) {
                  item.value.push(v.value);
                  item.setValue([...item.value]);
                } else {
                  item.setValue([v.value]);
                }
              }
            }}
            item={{ label: v.label }}
          />
        </div>
      ))}
    </div>
  );
}

function StepperForm({
  open,
  formAlert,
  setOpen,
  title,
  fields = [],
  steps = [],
  url,
  SubmitGeneralForm,
  onSuccess,
  col,
  maxWidth,
  useMaterial,
  buttonColor,
  buttonTitle,
  beforeSubmit,
  onError,
  systemSettings
}) {
  const mainBackground = systemSettings?.mainBackground;

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    control,
  } = useForm();
  const editor = React.useRef(null);
  const mPad = "-month-pad";
  const config = React.useMemo(
    () => ({
      present: "document",
      editHTMLDocumentMode: false,
      spellCheck: true,
      iframe: true,
      uploader: {
        insertImageAsBase64URI: true,
      },
      direction: "ltr",
      enter: "BR",
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
    }),
    []
  );


  useEffect(() => {
    watch((value, { name, type }) => {
      if (type === "change") {
        fields.forEach((v) => {
          const padName = `${v.name}${mPad}`;
          if (
            (name === v.name || padName === name) &&
            v.setValue &&
            typeof v.setValue === "function"
          ) {
            if (v.type === "date-month") {
              v.setValue(`${value[padName]}-${value[name]}`);
            } else {
              v.setValue(value[name]);
            }
          }
        });
      }
    });
  }, [watch, fields]);

  useEffect(() => {
    fields.forEach((v) => {
      if (v.type === "date-month") {
        if (v.value) {
          setValue(`${v.name}${mPad}`, v.value.split("-")[0]);
          setValue(v.name, v.value.split("-")[1]);
        } else {
          setValue(`${v.name}${mPad}`, null);
          setValue(v.name, null);
        }
      } else {
        setValue(v.name, v.value);
      }
    });
  }, [fields]);

  useEffect(() => {
    fields.forEach((v) => {
      if (v.type === "date-month") {
        if (v.value) {
          setValue(`${v.name}${mPad}`, v.value.split("-")[0]);
          setValue(v.name, v.value.split("-")[1]);
        } else {
          setValue(`${v.name}${mPad}`, null);
          setValue(v.name, null);
        }
      } else {
        setValue(v.name, v.value);
      }
    });
  }, [fields]);

  const onSubmit = async (formData) => {
    const payload = new FormData();
    const processFields = (fields, formData) => {
      return fields.reduce((acc, field) => {
        if (field.type === "group" && field.fields) {
          acc = {
            ...acc,
            ...processFields(field.fields, formData),
          };
        } else if (field.type === "array") {
          acc[field.name] = formData[field.name]?.map((item) => {
            return field.fields.reduce((itemAcc, subField) => {
              itemAcc[subField.name] = item[subField.name];
              return itemAcc;
            }, {});
          }) || [];
        } else {
          acc[field.name] = formData[field.name];
        }
        return acc;
      }, {});
    };

    // Structure main data object with step segregation
    const structuredData = steps.reduce((acc, step) => {
      const stepKey = step.label
        .toLowerCase()
        .replace(/(\s\w)/g, (match) => match.toUpperCase())
        .replace(/\s+/g, '');

      acc[stepKey] = processFields(step.fields, formData);
      return acc;
    }, {});

    fields.forEach((field) => {
      if (field.type === "file" && field.value) {
        if (field.multiple) {
          Array.from(field.value).forEach((file) =>
            payload.append(field.name, file)
          );
        } else {
          payload.append(field.name, field.value);
        }
      }
    });

    const finalPayload = {
      metadata: {
        formVersion: "1.0",
        steps: steps.map((step) => step.label),
      },
      data: structuredData,
    };

    payload.append("body", JSON.stringify(finalPayload.data));


    const resp = await SubmitGeneralForm(url, payload, "POST");
    if (resp.status) {
      successToast(getSuccessMessage(resp));
      handleClose();
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(resp);
      }
    } else {
      setError(getError(resp));
    }
    setLoading(false);
  };

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState();
  const handleClose = () => {
    fields?.map((v) => {
      if (v.setValue && typeof v.setValue === "function") {
        v.setValue(null);
      }
    });
    clearErrors();
    setOpen(0);
    setError(null);
  };

  // Function to format number with commas
  const formatNumber = (num) => {
    const numStr = num?.toString();
    return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Function to remove commas from number
  const unformatNumber = (num) => {
    num = num?.toString();
    return num?.replace(/,/g, "");
  };

  const disableWeekends = (weekDay) => {
    return weekDay === 0 || weekDay === 6;
  };
  useEffect(() => {
    fields.forEach((v) => {
      if (v.type === "date-month") {
        if (v.value) {
          setValue(`${v.name}${mPad}`, v.value.split("-")[0]);
          setValue(v.name, v.value.split("-")[1]);
        } else {
          setValue(`${v.name}${mPad}`, null);
          setValue(v.name, null);
        }
      } else {
        setValue(v.name, v.value);
      }
    });
  }, [fields]);

  const disablePastDates = (currentDate) => {
    const today = new Date();
    return currentDate.toDate() < today.setHours(0, 0, 0, 0);
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const formSteps = steps.length > 0 ? steps : [{ label: "Form", fields }];

  // const handleNext = () => {
  //   if (activeStep === formSteps.length - 1) {
  //     return;
  //   }
  //   setActiveStep(activeStep + 1);
  // };


  const [savedSteps, setSavedSteps] = useState({}); // Track saved steps

  const handleNext = async () => {
    try {
      const formData = watch();
      const currentStep = formSteps[activeStep];
      const config = stepEndpoints[currentStep.label];

      const errors = {};
      currentStep.fields.forEach((field) => {
        if (field.required && (!formData[field.name] || formData[field.name].trim() === "")) {
          errors[field.name] = `${field.label} is required`;
        }
      });

      if (Object.keys(errors).length > 0) {
        currentStep.fields.forEach((field) => {
          if (errors[field.name]) {
            setValue(field.name, formData[field.name], { shouldValidate: true });
          }
        });

        setError("Please fill in all required fields.");
        return;
      }
      clearErrors();

      const processFields = (fields, formData) => {
        return fields.reduce((acc, field) => {
          if (field.type === "group" && field.fields) {
            acc = {
              ...acc,
              ...processFields(field.fields, formData),
            };
          } else if (field.type === "array") {
            acc[field.name] = formData[field.name]?.map((item) => {
              return field.fields.reduce((itemAcc, subField) => {
                itemAcc[subField.name] = item[subField.name];
                return itemAcc;
              }, {});
            }) || [];
          } else {
            acc[field.name] = formData[field.name];
          }
          return acc;
        }, {});
      };

      if (!savedSteps[activeStep]) {
        // Save data only if it hasn't been saved yet
        if (activeStep === 0) {
          const stepData = processFields(currentStep.fields, formData);

          const response = await axios.post(config.endpoint, { body: stepData });

          if (response.data?.id) {
            setResourceId(response.data.id);
          }
        } else {
          if (!resourceId) throw new Error("Missing resource ID");

          const stepData = processFields(currentStep.fields, formData);

          if (activeStep === 2) {
            stepData["relationType"] = "spouse";
          }

          const payload = {
            resourceId,
            ...stepData,
          };

          await axios.post(config.endpoint, payload);
        }

        // Mark the current step as saved
        setSavedSteps((prev) => ({ ...prev, [activeStep]: true }));
      }
      setError(null);

      if (activeStep === formSteps.length - 1 || currentStep.label === "Referees") {
        const successMessage = getSuccessMessage("Employee created successfully");
        successToast(successMessage);
        handleClose();
        if (successMessage && typeof successMessage === "function") {
          onSuccess();
        }
        setOpen(false);
      } else {
        setActiveStep((prev) => prev + 1);
      }
    } catch (error) {
      const errorMessage = error?.data?.message || error.message;
      setError(errorMessage);
    }
  };

  const stepEndpoints = {
    "Personal Information": {
      endpoint: "/api/resource/create",
      dataKey: "main",
      method: "POST"
    },

    "Diasporas Details": {
      endpoint: "/api/resource/diaspora-info/create",
      dataKey: "diasporaInfo",
      method: "POST"
    },
    // "Civil Status": {
    //   endpoint: "/api/resource/family-relation/create",
    //   dataKey: "familyRelations",
    //   method: "POST"
    // },
    "Civil Status": {
      endpoint: "/api/resource/civil-status/create",
      dataKey: "civlStatus",
      method: "POST"
    },
    "Relative Details": {
      endpoint: "/api/resource/family-siblings/create",
      dataKey: "familyRelations",
      method: "POST"
    },

    "Parents Details": {
      endpoint: "/api/resource/parent-info/create",
      dataKey: "parentInfo",
      method: "POST"
    },
    "Criminal Record": {
      endpoint: "/api/resource/criminal-record/create",
      dataKey: "criminalRecords",
      method: "POST"
    },
    "Education Record": {
      endpoint: "/api/resource/education-history/create",
      dataKey: "educationHistory",
      method: "POST"
    },
    "Relative In Leadership Position": {
      endpoint: "/api/resource/leadership-relative/create",
      dataKey: "leadershipRelatives",
      method: "POST"
    },
    "Employement History": {
      endpoint: "/api/resource/employment-history/create",
      dataKey: "employmentHistory",
      method: "POST"
    },
    "Referees": {
      endpoint: "/api/resource/reference/create",
      dataKey: "referees",
      method: "POST"
    },
  };

  const [resourceId, setResourceId] = useState(null);

  const handleBack = () => {
    if (activeStep === 0) {
      return;
    }
    setActiveStep(activeStep - 1);
  };

  return (
    <div>

      <Dialog
        fullWidth={true}
        maxWidth={maxWidth ?? "sm"}
        open={open}
        onClose={handleClose}
      >
        {loading ? (
          <div
            className={
              "absolute h-full w-full top-0 left-0 flex z-50 justify-center items-center"
            }
            style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
          >
            <div
              className={"bg-white p-3 rounded shadow text-center"}
              style={{ zIndex: 20000 }}
            >
              <div>
                <CircularProgress color={"success"} />
              </div>
              <span>
                <Typography>Submitting ....</Typography>
              </span>
            </div>
          </div>
        ) : null}
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>
            <div className={"flex items-center"}>
              <div className={"flex-grow font-bold text-lg"}>
                {title ?? "Form"}
              </div>
              <IconButton onClick={handleClose}>
                <img
                  src={require("assets/icons/close.svg").default}
                  alt={"close"}
                />
              </IconButton>
            </div>
          </DialogTitle>

          {formSteps.length > 1 && (
            <Box sx={{ px: 3, pt: 2 }}>
              <Stepper activeStep={activeStep} alternativeLabel sx={{
                '& .MuiStepIcon-root.Mui-active': { color: mainBackground },
                '& .MuiStepIcon-root.Mui-completed': { color: mainBackground }
              }}>
                {formSteps.map((step) => (
                  <Step key={step.label}>
                    <StepLabel>{step.label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          )}
          <DialogContent className={"pt-2"}>
            {formAlert ? (
              <Alert
                style={{ width: "100%" }}
                className={"mb-3"}
                severity={"warning"}
              >
                {formAlert}
              </Alert>
            ) : null}

            {error ? (
              <Alert
                style={{ width: "100%" }}
                className={"mb-3"}
                severity={"error"}
                onClose={() => setError(null)}
              >
                {error}
              </Alert>
            ) : null}
            <div className={"flex flex-wrap"}>
              {formSteps.length > 1 &&
                formSteps[activeStep].fields?.map((v) => {
                  if (v.hidden) {
                    return null;
                  }

                  if (v.showIf && !v.showIf(watch())) return null;

                  if (v.type === "group") {
                    return (
                      <div
                        key={v.name}
                        className="w-full px-2 mb-4"
                        style={v.style || { border: "1px solid #ccc", padding: "10px", borderRadius: "5px" }}
                      >
                        <Typography variant="subtitle1" gutterBottom>
                          {v.label}
                          {v.required && <span className="text-red-500 font-bold ml-1">*</span>}
                        </Typography>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {v.fields?.map((subField) => {
                            const nestedValidation = register(subField.name, {
                              required: subField.required ? `${subField.label} is required!!!` : false,
                              validate: subField.validate
                            });

                            return (
                              <div key={subField.name} className="mb-3">
                                <Controller
                                  name={subField.name}
                                  control={control}
                                  rules={{
                                    required: subField.required ? `${subField.label} is required!!!` : false,
                                    validate: subField.validate
                                  }}
                                  render={({ field, fieldState: { error } }) => {
                                    const commonProps = {
                                      ...field,
                                      error: !!error,
                                      helperText: error?.message,
                                      fullWidth: true,
                                      size: "small",
                                      variant: "outlined",
                                      label: subField.label,
                                      required: subField.required
                                    };

                                    switch (subField.type) {
                                      case "text":
                                        return (
                                          <TextField
                                            {...commonProps}
                                            value={field.value || ""}
                                            onChange={(e) => {
                                              field.onChange(e.target.value);
                                              if (subField.setValue) {
                                                subField.setValue(e.target.value);
                                              }
                                            }}
                                          />
                                        );

                                      case "select":
                                        return (
                                          <FormControl fullWidth size="small" error={!!error}>
                                            <InputLabel>{subField.label}</InputLabel>
                                            <Select
                                              {...commonProps}
                                              value={field.value || ""}
                                              onChange={(e) => {
                                                field.onChange(e.target.value);
                                                if (subField.setValue) {
                                                  subField.setValue(e.target.value);
                                                }
                                              }}
                                            >
                                              {subField.values?.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                            {error && (
                                              <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                            )}
                                          </FormControl>
                                        );

                                      case "date":
                                        return (
                                          <TextField
                                            {...commonProps}
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            value={field.value || ""}
                                            onChange={(e) => {
                                              field.onChange(e.target.value);
                                              if (subField.setValue) {
                                                subField.setValue(e.target.value);
                                              }
                                            }}
                                          />
                                        );

                                      default:
                                        return null;
                                    }
                                  }}
                                />
                                {errors[subField.name] && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {errors[subField.name].message}
                                  </p>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  }


                  if (v.type === "array") {
                    const arrayValues = watch(v.name) || [];
                    return (
                      <div key={v.name} className={`w-full px-2 mb-4`}>
                        <div className="flex items-center justify-between mb-2">
                          <Typography variant="subtitle1">
                            {v.label}
                            {v.required && <span className="text-red-500 font-bold ml-1">*</span>}
                          </Typography>
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{ color: mainBackground }}
                            onClick={() => setValue(v.name, [...arrayValues, {}])}
                          >
                            Add {v.itemLabel || "Item"}
                          </Button>
                        </div>

                        {arrayValues.map((item, index) => (
                          <div key={index} className="mb-4 p-3 border rounded">
                            <div className="flex justify-between items-center mb-2">
                              <Typography variant="body2">
                                {v.itemLabel?.(index, arrayValues) || `Item ${index + 1}`}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  const newArray = arrayValues.filter((_, i) => i !== index);
                                  setValue(v.name, newArray);
                                }}
                              >
                                <CloseRounded fontSize="small" />
                              </IconButton>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {v.fields?.map((subField) => {
                                const nestedName = `${v.name}.${index}.${subField.name}`;
                                const nestedField = {
                                  ...subField,
                                  name: nestedName,
                                  value: watch(nestedName),
                                  setValue: (val) => {
                                    setValue(nestedName, val);
                                    if (subField.setValue && typeof subField.setValue === "function") {
                                      subField.setValue(val, index);
                                    }
                                  },
                                };

                                if (nestedField.showIf && !nestedField.showIf(watch(), index)) {
                                  return null;
                                }

                                return (
                                  <div key={nestedName} className="mb-3">
                                    <Controller
                                      name={nestedName}
                                      control={control}
                                      rules={{
                                        required: subField.required ? `${subField.label} is required!!!` : false,
                                        validate: subField.validate,
                                        min: subField.min,
                                        max: subField.max,
                                        pattern: subField.pattern
                                      }}
                                      render={({ field, fieldState: { error } }) => {
                                        const commonProps = {
                                          ...field,
                                          error: !!error,
                                          helperText: error?.message,
                                          fullWidth: true,
                                          size: "small",
                                          variant: "outlined",
                                          label: subField.label,
                                          required: subField.required
                                        };

                                        switch (subField.type) {
                                          case "text":
                                            return (
                                              <TextField
                                                {...commonProps}
                                                value={field.value || ""}
                                                onChange={(e) => {
                                                  field.onChange(e.target.value);
                                                  nestedField.setValue(e.target.value);
                                                }}
                                              />
                                            );

                                          case "select":
                                            const options = typeof subField.values === 'function'
                                              ? subField.values(index)
                                              : subField.values || [];

                                            return (
                                              <FormControl fullWidth size="small" error={!!error}>
                                                <InputLabel>{subField.label}</InputLabel>
                                                <Select
                                                  {...commonProps}
                                                  value={field.value || ""}
                                                  onChange={(e) => {
                                                    field.onChange(e.target.value);
                                                    nestedField.setValue(e.target.value);
                                                  }}
                                                >
                                                  {options.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                    </MenuItem>
                                                  ))}
                                                </Select>
                                                {error && (
                                                  <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                                )}
                                              </FormControl>
                                            );

                                          case "date":
                                            return (
                                              <TextField
                                                {...commonProps}
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                value={field.value || ""}
                                                onChange={(e) => {
                                                  field.onChange(e.target.value);
                                                  nestedField.setValue(e.target.value);
                                                }}
                                              />
                                            );

                                          default:
                                            return null;
                                        }
                                      }}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  }

                 
                  if (v.type === "radio") {
                    return (
                      <div key={v.name} className="w-full px-2 mb-4">
                        <FormControl component="fieldset" error={!!errors[v.name]}>
                          <FormLabel
                            component="legend"
                            sx={{
                              color: "inherit",
                              "&.Mui-focused": {
                                color: mainBackground,
                              },
                            }}
                          >
                            {v.label}
                            {v.required && <span className="text-red-500 font-bold ml-1">*</span>}
                          </FormLabel>
                          <Controller
                            name={v.name}
                            control={control}
                            rules={{
                              required: v.required ? `${v.label} is required!!!` : false,
                              validate: v.validate
                            }}
                            render={({ field, fieldState: { error } }) => (
                              <>
                                <RadioGroup
                                  {...field}
                                  aria-required={v.required}
                                  required={v.required}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    v.setValue(e.target.value);
                                  }}
                                >
                                  <div className="flex gap-4">
                                    {v.values.map((option) => (
                                      <FormControlLabel
                                        key={option.value}
                                        value={option.value}
                                        control={
                                          <Radio
                                            sx={{
                                              color: error ? "#d32f2f" : (
                                                field.value === option.value ? mainBackground : "default"
                                              ),
                                              "&.Mui-checked": {
                                                color: error ? "#d32f2f" : mainBackground,
                                              },
                                            }}
                                          />
                                        }
                                        label={option.label}
                                      />
                                    ))}
                                  </div>
                                </RadioGroup>
                                {error && (
                                  <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                )}
                              </>
                            )}
                          />
                        </FormControl>
                      </div>
                    );
                  }

                  let requiredRule = {
                    required: v.required ? `${v.label} is required !!!` : false,
                  };

                  if (
                    v.maxDate ||
                    v.minDate ||
                    typeof v.validate === "function"
                  ) {
                    requiredRule = {
                      ...requiredRule,
                      validate: (val) => {
                        let resp = true;
                        if (v.maxDate) {
                          resp = moment(val).isSameOrBefore(v.maxDate)
                            ? true
                            : `Date can't be greater than ${v.maxDate.format(
                              "YYYY-MMM-DD"
                            )}`;
                        }

                        if (resp === true && v.minDate) {
                          resp = moment(val).isSameOrAfter(v.minDate)
                            ? true
                            : `Date can't be less than ${v.minDate.format(
                              "YYYY-MMM-DD"
                            )}`;
                        }

                        if (typeof v.validate === "function") {
                          return v.validate(val, v) ?? resp;
                        }

                        return resp;
                      },
                    };
                  }

                  const validationProps = register(v.name, {
                    ...requiredRule,
                    max: v.hasOwnProperty("max")
                      ? {
                        value: v.max,
                        message: `Maximum number is ${v.max?.toLocaleString()}`,
                      }
                      : undefined,
                    min: v.hasOwnProperty("min")
                      ? {
                        value: v.min,
                        message: `Minimum number is ${v.min?.toLocaleString()}`,
                      }
                      : undefined,
                    minLength: v.hasOwnProperty("minLength")
                      ? {
                        value: v.minLength,
                        message: `Minimum length is ${v.minLength?.toLocaleString()}`,
                      }
                      : undefined,
                    maxLength: v.hasOwnProperty("maxLength")
                      ? {
                        value: v.maxLength,
                        message: `Maximum length is ${v.maxLength?.toLocaleString()}`,
                      }
                      : undefined,
                    pattern:
                      v.type === "tel"
                        ? {
                          value: /^(^\+?(?:[+0]9)?[0-9]{8,14}$)$/i,
                          message: "Invalid Phone number",
                        }
                        : v.type === "email"
                          ? {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          }
                          : null,
                  });

                  const type = v.type === "email" ? "text" : v.type ?? "text";

                  const mPadName = `${v.name}${mPad}`;

                  const hasError =
                    errors[v.name] ||
                    (v.type === "date-month" && errors[mPadName]);

                  const className = `${v.disabled ? "bg-gray-500 disabled:opacity-75" : ""
                    } ${hasError ? "border border-red-500" : "border-1 "
                    } px-3 py-3 border-input placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150`;

                  const label = (
                    <label
                      style={{ color: "#333333" }}
                      className={`block uppercase text-xs font-normal ${v.type === "switch" ? "" : "mb-2"
                        }`}
                      htmlFor={v.id}
                    >
                      {v.label}
                      {v.required ? (
                        <span className={"text-red-500 font-bold ml-1"}>*</span>
                      ) : null}
                    </label>
                  );

                  if (typeof v.render === "function") {
                    return (
                      <div
                        className={`mb-3 mt-2 w-full lg:w-${v.col ?? col ?? 12
                          }/12 xl:w-${v.col ?? col ?? 12}/12 px-2`}
                      >
                        {label}
                        {v.render()}
                      </div>
                    );
                  }

                  // Update the main return statement for regular fields
                  return (
                    <div
                      className={`mb-3 mt-2 w-full lg:w-${v.col ?? col ?? 12}/12 xl:w-${v.col ?? col ?? 12}/12 px-2`}
                    >
                      {v.type === "switch" ? (
                        <div className={"flex items-center"}>
                          {label}
                          <Controller
                            control={control}
                            rules={{
                              ...requiredRule,
                            }}
                            name={v.name}
                            render={({ field, fieldState: { error } }) => (
                              <>
                                <Switch
                                  className={error?.message ? "border-red-500" : undefined}
                                  value={field.value ?? ""}
                                  name={v.name}
                                  checked={field.value === "1"}
                                  onChange={(event, checked) => {
                                    if (v.setValue && typeof v.setValue === "function") {
                                      setValue(v.name, `${checked ? 1 : 0}`);
                                      field.onChange(`${checked ? 1 : 0}`);
                                    }
                                  }}
                                />
                                {error && (
                                  <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                )}
                              </>
                            )}
                          />
                        </div>
                      ) : v.type === "number" && v.isNumber === true ? (
                        <div>
                          {label}
                          <Controller
                            control={control}
                            rules={{
                              ...requiredRule,
                              validate: v.required
                                ? (val) => val && !isNaN(unformatNumber(val))
                                : undefined,
                            }}
                            name={v.name}
                            render={({ field, fieldState: { error } }) => (
                              <>
                                <input
                                  type="text"
                                  value={formatNumber(field.value ?? "")}
                                  onChange={(e) => {
                                    const unformattedValue = unformatNumber(e.target.value);
                                    if (!isNaN(unformattedValue)) {
                                      setValue(v.name, unformattedValue);
                                      field.onChange(unformattedValue);
                                    }
                                  }}
                                  className={error?.message ? "border-red-500" : className}
                                  placeholder={v?.placeholder}
                                />
                                {error && (
                                  <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                )}
                              </>
                            )}
                          />
                        </div>
                      ) : v.type === "editor" ? (
                        <div>
                          {label}
                          <Controller
                            control={control}
                            rules={{
                              ...requiredRule,
                              validate: v.required
                                ? (val) => {
                                  if (!val) return requiredRule.required;
                                  const $ = cheerio.load(val);
                                  return $.text()?.trim()?.length
                                    ? true
                                    : requiredRule.required;
                                }
                                : undefined,
                            }}
                            name={v.name}
                            render={({ field, fieldState: { error } }) => (
                              <>
                                <JoditEditor
                                  config={config}
                                  ref={editor}
                                  className={error?.message ? "border-red-500" : undefined}
                                  value={field.value ?? ""}
                                  onBlur={(newContent) => {
                                    if (v.setValue && typeof v.setValue === "function") {
                                      setValue(v.name, newContent);
                                      field.onChange(newContent);
                                    }
                                  }}
                                />
                                {error && (
                                  <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                )}
                              </>
                            )}
                          />
                        </div>
                      ) : v.type === "file-drag" ? (
                        <div>
                          {label}
                          <Controller
                            control={control}
                            rules={requiredRule}
                            name={v.name}
                            render={({ fieldState: { error } }) => (
                              <>
                                <FileUploader
                                  multiple={v.multiple ?? false}
                                  classes={`${error ? "border-red-500" : ""} w-full flex-grow-1 max-width-full-i min-width-full`}
                                  style={{ maxWidth: "auto !important" }}
                                  id={v.id}
                                  handleChange={(e) => {
                                    if (v.setValue && typeof v.setValue === "function") {
                                      v.setValue(e);
                                    }
                                  }}
                                  name="file"
                                  types={fileTypes}
                                />
                                {error && (
                                  <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                )}
                              </>
                            )}
                          />
                        </div>
                      ) : v.type === "checkbox" ? (
                        <div>
                          {label}
                          <Controller
                            control={control}
                            rules={{
                              validate: (value) =>
                                !v.required || (value?.length > 0) || `${v.label} is required!!!`
                            }}
                            name={v.name}
                            render={({ fieldState: { error } }) => (
                              <>
                                <CheckBoxItem item={v} />
                                {error && (
                                  <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                )}
                              </>
                            )}
                          />
                        </div>
                      ) : v.type === "select" ? (
                        useMaterial ? (
                          <FormControl fullWidth size="small" error={!!errors[v.name]}>
                            <InputLabel>{v.label}</InputLabel>
                            <Controller
                              name={v.name}
                              control={control}
                              rules={requiredRule}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  native={true}
                                  disabled={v.disabled ?? false}
                                  label={v.label}
                                >
                                  <option value=""></option>
                                  {v.values?.map((item) => (
                                    <option value={item.value}>{item.label}</option>
                                  ))}
                                </Select>
                              )}
                            />
                            {errors[v.name] && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors[v.name].message}
                              </p>
                            )}
                          </FormControl>
                        ) : (
                          <div className="relative w-full">
                            {label}
                            <Controller
                              name={v.name}
                              control={control}
                              rules={requiredRule}
                              render={({ field, fieldState: { error } }) => (
                                <>
                                  <select
                                    {...field}
                                    className={`${className} ${error ? "border-red-500" : ""}`}
                                    disabled={v.disabled ?? false}
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                      if (v.setValue) v.setValue(e.target.value);
                                    }}
                                  >
                                    <option value=""></option>
                                    {v.values?.map((item) => (
                                      <option value={item.value}>{item.label}</option>
                                    ))}
                                  </select>
                                  {error && (
                                    <p className="text-red-500 text-xs mt-1">{error.message}</p>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        )
                      ) : useMaterial ? (
                        <Controller
                          name={v.name}
                          control={control}
                          rules={requiredRule}
                          render={({ field, fieldState: { error } }) => (
                            <TextField
                              {...field}
                              error={!!error}
                              helperText={error?.message}
                              autoFocus
                              id={v.id}
                              disabled={v.disabled ?? false}
                              label={v.label}
                              minRows={v.type === "textarea" ? 5 : null}
                              type={type}
                              fullWidth
                              InputLabelProps={
                                ["date", "file", "datetime-local"].includes(v.type)
                                  ? { shrink: true }
                                  : {}
                              }
                              size="small"
                              variant="outlined"
                            />
                          )}
                        />
                      ) : (
                        <div className="relative w-full">
                          {label}
                          <Controller
                            name={v.name}
                            control={control}
                            rules={requiredRule}
                            render={({ field, fieldState: { error } }) => (
                              <>
                                {v.type === "textarea" ? (
                                  <textarea
                                    {...field}
                                    rows={v.rows ?? 3}
                                    placeholder={v?.placeholder}
                                    disabled={v.disabled ?? false}
                                    className={`${className} ${error ? "border-red-500" : ""}`}
                                  ></textarea>
                                ) : v.type === "date-month" ? (
                                  <div className="flex w-full">
                                    <div className="flex-grow">
                                      <select
                                        {...register(`${v.name}${mPad}`, requiredRule)}
                                        className={`${className} ${errors[`${v.name}${mPad}`] ? "border-red-500" : ""}`}
                                      >
                                        <option value="">-- Day --</option>
                                        {getDateList().map((day) => (
                                          <option value={day.toString().padStart(2, "0")}>
                                            {day.toString().padStart(2, "0")}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className="flex-grow">
                                      <select
                                        {...register(v.name, requiredRule)}
                                        className={`${className} ${errors[v.name] ? "border-red-500" : ""}`}
                                      >
                                        <option value="">-- Month --</option>
                                        {monthList.map((month) => (
                                          <option
                                            value={month.value.toString().padStart(2, "0")}
                                          >
                                            {month.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                ) : v.type === "date" && v.weekendDisabled === true ? (
                                  <DatePicker
                                    {...field}
                                    disabled={v.disabled ?? false}
                                    className={`${className} ${error ? "border-red-500" : ""}`}
                                    style={{ padding: "15px" }}
                                    minDate={v.minDate?.format("YYYY-MM-DD")}
                                    maxDate={v.maxDate?.format("YYYY-MM-DD")}
                                    onChange={(value) => {
                                      const date = moment(value).format("YYYY-MM-DD");
                                      field.onChange(date);
                                      if (v.setValue) v.setValue(date);
                                    }}
                                    placeholder="Select a date"
                                    mapDays={disableWeekends}
                                  />
                                ) : (
                                  <input
                                    {...field}
                                    type={type}
                                    placeholder={v?.placeholder}
                                    className={`${className} ${error ? "border-red-500" : ""}`}
                                    min={v.minDate?.format("YYYY-MM-DD")}
                                    max={v.maxDate?.format("YYYY-MM-DD")}
                                    disabled={v.disabled ?? false}
                                  />
                                )}
                                {(errors[v.name] || errors[`${v.name}${mPad}`]) && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {errors[v.name]?.message || errors[`${v.name}${mPad}`]?.message}
                                  </p>
                                )}
                              </>
                            )}
                          />
                        </div>
                      )}
                    </div>
                  );
                  
                })}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} type={"button"}
              sx={{ color: "red" }}>
              Cancel
            </Button>
            {formSteps.length > 1 && activeStep > 0 && (
              <Button
                onClick={handleBack}
              >
                Back
              </Button>
            )}

            {formSteps.length > 1 ? (
              activeStep < formSteps.length ? (
                <Button
                  onClick={() => handleNext()}
                  variant="contained"

                  sx={{
                    backgroundColor: mainBackground,
                    color: "#fff",
                    "&:hover": { backgroundColor: mainBackground },
                  }}
                >
                  Save & Continue
                </Button>
              ) : (
                <QtMaterialButton
                  color={buttonColor ?? "info"}
                  variant={"contained"}
                  type={"submit"}
                >
                  {buttonTitle ?? "Submit"}
                </QtMaterialButton>
              )
            ) : (
              <QtMaterialButton
                color={buttonColor ?? "info"}
                variant={"contained"}
                type={"submit"}
              >
                {buttonTitle ?? "Submit"}
              </QtMaterialButton>
            )}
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(StepperForm);
